import { render, staticRenderFns } from "./GeneratedWord.vue?vue&type=template&id=0f67b216"
import script from "./GeneratedWord.vue?vue&type=script&lang=js"
export * from "./GeneratedWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports